import './product-small.component.scss';
//import app from '../../helpers/js/app';;